import { REGULATED_SITE_HOSTS } from '@bfe/by-env';
import React, { FC, useEffect, useState } from 'react';

const MigrationEntry: FC = () => {
  const [isShowEntry, setIsShowEntry] = useState(false);
  // const getMigrationEntry = async () => {
  //   try {
  //     const instance = await window.ByGlobals.loadComponent(
  //       'migrationEntry',
  //       'migration-entry',
  //       {
  //         extraProps: {
  //           theme: 'light',
  //           originalSite: 'NLD',
  //           targetSite: 'EU',
  //         },
  //       },
  //     );

  //     if (!instance) {
  //       throw new Error('Failed to load component');
  //     }
  //   } catch (error) {
  //     console.error('Failed to load :', error);
  //   }
  // };
  useEffect(() => {
    setIsShowEntry(
      REGULATED_SITE_HOSTS === 'EU' || REGULATED_SITE_HOSTS === 'NLD',
    );
  }, []);
  useEffect(() => {
    let migrationEntryInstance: any;
    if (isShowEntry && window.BybitUniFrame) {
      // getMigrationEntry()
      window.BybitUniFrame?.ready?.(({ migrationEntry }) => {
        migrationEntryInstance = migrationEntry;
        // 基于id选择器 render 对应的ui界面
        migrationEntry
          ?.init?.({ containerId: 'migration-entry' })
          ?.then?.((migrationEntryComp) => {
            // 获取注册属性
            const { EXTRA_PROPS } = migrationEntryComp.properties;
            // 获取注册事件
            const { HIDE_CALLBACK } = migrationEntryComp.events;

            // 订阅事件，绑定回调函数
            migrationEntryComp
              .setProperty(EXTRA_PROPS, {
                theme: 'light',
                originalSite: 'NLD',
                targetSite: 'EU',
              })
              .subscribeEvent(HIDE_CALLBACK, () => {
                console.log('hide');
              });
          });
      });
    }
    return () => {
      if (migrationEntryInstance) {
        migrationEntryInstance.dealloc();
      }
    };
  }, [isShowEntry]);
  if (!isShowEntry) {
    return null;
  }
  return <div id="migration-entry" style={{ padding: '16px 0' }}></div>;
};
export default MigrationEntry;
